import { render, staticRenderFns } from "./AddAnswers.vue?vue&type=template&id=d268b2d0&scoped=true"
import script from "./AddAnswers.vue?vue&type=script&lang=js"
export * from "./AddAnswers.vue?vue&type=script&lang=js"
import style0 from "./AddAnswers.vue?vue&type=style&index=0&id=d268b2d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d268b2d0",
  null
  
)

export default component.exports